
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaitogoacab() {



    const cardData =
    {
        keyword: 'Navi Mumbai to Goa Cab Service',
        heading: 'Skyline Cabs: Navi Mumbai to Goa Cab Service',
        headingDescription: 'Skyline Cabs offers comfortable and reliable Navi Mumbai to Goa Cab Service for a scenic and stress-free coastal journey. Whether you are heading to Goa for a beach vacation, a party getaway, or a relaxing retreat, our well-maintained vehicles and professional drivers ensure a smooth and enjoyable ride. Enjoy door-to-door pickups from anywhere in Navi Mumbai, transparent pricing, flexible travel schedules, and 24/7 customer support. Book your Navi Mumbai to Goa cab with Skyline Cabs today and experience a hassle-free trip to India’s most loved beach destination!',

        top: 'Top Places to Visit in Mumbai with Skyline Cabs',

"topPlaces": [
    {
        "title": "Baga Beach",
        "description": "One of the most popular beaches in Goa, Baga Beach is known for its vibrant nightlife, water sports, and golden sands. It’s a great place to relax during the day and enjoy beach parties and shacks at night."
    },
    {
        "title": "Fort Aguada",
        "description": "A 17th-century Portuguese fort, Fort Aguada offers panoramic views of the Arabian Sea. The fort also houses a lighthouse and is a popular historical site for those interested in Goa's colonial past."
    },
    {
        "title": "Basilica of Bom Jesus",
        "description": "A UNESCO World Heritage Site, this stunning baroque church in Old Goa is famous for housing the mortal remains of St. Francis Xavier. It’s one of the oldest churches in India, attracting both history buffs and religious visitors."
    },
    {
        "title": "Anjuna Beach",
        "description": "Known for its laid-back atmosphere, Anjuna Beach is a favorite among backpackers and party-goers. The beach features vibrant flea markets, beachside shacks, and picturesque views of the Arabian Sea."
    },
    {
        "title": "Dudhsagar Waterfalls",
        "description": "Located on the Goa-Karnataka border, Dudhsagar Waterfalls is one of the tallest and most majestic waterfalls in India. The falls are surrounded by lush greenery, making it an ideal spot for nature lovers and trekkers."
    },
    {
        "title": "Palolem Beach",
        "description": "A crescent-shaped beach in South Goa, Palolem is known for its calm waters, clean sand, and relaxed atmosphere. It’s perfect for kayaking, yoga, or just unwinding in a peaceful beach hut."
    },
    {
        "title": "Shri Mangueshi Temple",
        "description": "One of the largest and most prominent temples in Goa, Shri Mangueshi Temple is dedicated to Lord Shiva. The temple is known for its beautiful architecture and serene surroundings."
    },
    {
        "title": "Vasco da Gama",
        "description": "A historic town in Goa, Vasco da Gama is known for its colonial heritage, bustling markets, and scenic views. It’s also the location of the Dabolim Airport, making it a convenient base for exploring Goa."
    },
    {
        "title": "Chapora Fort",
        "description": "Famous for its appearance in the movie *Dil Chahta Hai*, Chapora Fort offers stunning views of Vagator Beach and the Arabian Sea. It’s a great spot for history enthusiasts and photography lovers."
    },
    {
        "title": "Calangute Beach",
        "description": "One of the most popular beaches in North Goa, Calangute Beach offers a vibrant atmosphere with numerous water sports, beach shacks, and a variety of shopping options. It’s ideal for both relaxation and adventure."
    }
],

"services": [
    {
      "name": "Navi Mumbai to Goa Cab",
      "description": "Skyline Cabs offers reliable and comfortable taxi services from Navi Mumbai to Goa. Enjoy a smooth and scenic ride to the beautiful beaches of Goa."
    },
    {
      "name": "Navi Mumbai Goa Taxi Service",
      "description": "Book a Goa taxi from Navi Mumbai with Skyline Cabs. Our services are designed to ensure your travel is safe, comfortable, and convenient."
    },
    {
      "name": "Navi Mumbai to Goa One Way Taxi",
      "description": "Rent a one-way taxi from Navi Mumbai to Goa with Skyline Cabs. Ideal for travelers looking for a convenient and direct journey."
    },
    {
      "name": "Goa Trip Taxi from Navi Mumbai",
      "description": "Plan your Goa trip with Skyline Cabs. Book a taxi from Navi Mumbai for a comfortable, enjoyable, and stress-free journey."
    },
    {
      "name": "Outstation Cab Service Navi Mumbai to Goa",
      "description": "Skyline Cabs provides outstation cab services from Navi Mumbai to Goa. Enjoy a comfortable and reliable ride with experienced drivers."
    }
  ],
  "tableData": [
    ["Navi Mumbai to Goa Cab", "Navi Mumbai Goa Taxi Service"],
    ["Navi Mumbai to Goa One Way Taxi", "Goa Trip Taxi from Navi Mumbai"],
    ["Outstation Cab Service Navi Mumbai to Goa"]
  ],



  whychoose: [
    {
      "WhyChooseheading": "Navi Mumbai to Goa Cab Service",
      "WhyChoosedescription": "Travel from Navi Mumbai to Goa in comfort and style with our reliable cab service. Whether it’s for a vacation, business trip, or a group outing, we ensure a smooth and hassle-free journey."
    },
    {
      "WhyChooseheading": "Comfortable and Long-Distance Ready Cabs",
      "WhyChoosedescription": "Our cabs are perfect for long journeys, offering comfortable seating, smooth suspension, and a relaxing ride to ensure you enjoy the scenic drive from Navi Mumbai to Goa."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "We provide competitive, budget-friendly pricing for Navi Mumbai to Goa cab rentals, with no hidden charges. Enjoy transparent rates and a stress-free journey."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are skilled and knowledgeable, experienced in long-distance travel, ensuring that you reach Goa safely and on time, while maintaining a courteous and professional service."
    },
    {
      "WhyChooseheading": "Well-Maintained and Sanitized Vehicles",
      "WhyChoosedescription": "All our vehicles are regularly maintained, cleaned, and sanitized to provide the highest standards of hygiene, safety, and comfort for your road trip to Goa."
    },
    {
      "WhyChooseheading": "Flexible Travel Options",
      "WhyChoosedescription": "Whether it’s a one-way trip, round trip, or multi-day journey, we offer flexible travel packages that suit your specific plans from Navi Mumbai to Goa."
    },
    {
      "WhyChooseheading": "24/7 Customer Support and Easy Booking",
      "WhyChoosedescription": "Booking your Navi Mumbai to Goa cab is simple with our online platform or over the phone. Our 24/7 customer support team ensures a smooth and hassle-free booking experience."
    },
    {
      "WhyChooseheading": "Ideal for Vacation, Business, or Group Travel",
      "WhyChoosedescription": "Our cabs cater to every kind of travel—from relaxing vacations and corporate trips to group outings—ensuring comfort and reliability on your journey from Navi Mumbai to Goa."
    }
  ]
  
  
  
  
  









    }

    const faqData = [
        {
            id: 1,
            question: 'How can I book a cab from Navi Mumbai to Goa with Skyline Cabs?',
            answer:
                'Booking a cab from Navi Mumbai to Goa is simple and convenient. You can book through our website, mobile app, or by calling customer support. Just enter your pickup location (Navi Mumbai), destination (Goa), travel date, and preferred vehicle to finalize your booking.',
        },
        {
            id: 2,
            question: 'What is the distance and travel time from Navi Mumbai to Goa?',
            answer:
                'The distance from Navi Mumbai to Goa is approximately 590 km. The travel time typically ranges from 9 to 11 hours, depending on the road conditions and traffic. Our drivers are experienced and take the best routes for a smooth and timely journey.',
        },
        {
            id: 3,
            question: 'What types of vehicles are available for the Navi Mumbai to Goa trip?',
            answer:
                'We offer a wide range of vehicles for your Navi Mumbai to Goa trip, including Swift Dzire, Ertiga, Innova Crysta, Kia Carens, and SUVs. For larger groups or special requirements, we also provide Tempo Travellers and luxury coaches.',
        },
        {
            id: 4,
            question: 'Are your cab fares for Navi Mumbai to Goa fixed?',
            answer:
                'Yes, we offer fixed and transparent pricing for your Navi Mumbai to Goa trip. The fare includes vehicle rental, driver charges, fuel, tolls, taxes, and service fees. You will know the total cost before confirming your booking.',
        },
        {
            id: 5,
            question: 'Can I book a one-way cab from Navi Mumbai to Goa?',
            answer:
                'Yes, we offer one-way cab options for your journey from Navi Mumbai to Goa. You can also choose a round-trip service if you plan to return to Navi Mumbai at a later time.',
        },
        {
            id: 6,
            question: 'What is the best time to travel from Navi Mumbai to Goa?',
            answer:
                'The best time to travel to Goa is between October and March when the weather is cooler. However, Skyline Cabs operates year-round, and our experienced drivers are well-prepared to handle various weather conditions throughout the year.',
        },
        {
            id: 7,
            question: 'Are stopovers allowed during the Navi Mumbai to Goa journey?',
            answer:
                'Yes, we allow stopovers during your Navi Mumbai to Goa journey for breaks, meals, or sightseeing. Just inform your driver if you’d like to make any stops along the way.',
        },
        {
            id: 8,
            question: 'What payment options are available for the Navi Mumbai to Goa cab?',
            answer:
                'We accept a variety of payment methods, including UPI, credit/debit cards, net banking, and cash payments after the trip. All online payments are securely processed through trusted payment gateways.',
        },
        {
            id: 9,
            question: 'Can I cancel or modify my Navi Mumbai to Goa cab booking?',
            answer:
                'Yes, you can modify or cancel your booking easily via our website, mobile app, or by contacting customer support. We offer flexible cancellation policies to accommodate changes in your plans.',
        },
        {
            id: 10,
            question: 'Why should I choose Skyline Cabs for the Navi Mumbai to Goa trip?',
            answer:
                'Skyline Cabs provides a comfortable, safe, and reliable journey from Navi Mumbai to Goa. With a fleet of well-maintained vehicles, experienced drivers, and transparent pricing, we ensure that your trip is smooth and hassle-free.',
        },
    ];
    
    const someReviews = [
        {
            name: "Mr. Vijay Mehta",
            rating: 5,
            review: "Booked a cab from Navi Mumbai to Goa with Skyline Cabs. The vehicle was comfortable, and the driver was professional. The journey was smooth and timely. Will definitely use their services again."
        },
        {
            name: "Miss. Ritu Sharma",
            rating: 4,
            review: "Great experience traveling from Navi Mumbai to Goa with Skyline Cabs. The car was clean and spacious. The only issue was a slight delay at the beginning, but overall, the service was excellent."
        },
    ];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];

    const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Goa Cabs",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-to-goa-cabs.jpg",
  "description": "Book Navi Mumbai to Goa cabs with Skyline Cabs for a safe, scenic, and comfortable ride. Choose from AC sedans, SUVs, or luxury vehicles for one-way or round trips with 24/7 availability and professional chauffeurs.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "7885"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6299",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-to-goa-cabs"
  }
};



      
     



    return (
        <div>
<Helmet>
  <title>Navi Mumbai to Goa Cabs | One-Way & Round Trip Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai to Goa cabs with Skyline Cabs for a safe, scenic, and comfortable ride. Choose from AC sedans, SUVs, or luxury vehicles for one-way or round trips with 24/7 availability and professional chauffeurs." 
  />
  <meta 
    name="keywords" 
    content="Navi Mumbai to Goa Cabs, One Way Taxi Navi Mumbai to Goa, Round Trip Cab Navi Mumbai to Goa, AC Sedan Cab Goa from Navi Mumbai, SUV Cab Hire Navi Mumbai to Goa, Skyline Cabs Goa Booking, Outstation Cabs Navi Mumbai, Luxury Taxi Navi Mumbai to Goa, 24/7 Taxi Service Navi Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/98.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaitogoacab;